import { authAxios as axios } from "shared-auth";
import queryString from "query-string";

import config from "config/global";

import {
  ISelfTapeRequestNotification,
  ISelfTapeRequestNotificationFilterParams,
  ISelfTapeRequestNotificationFilters,
  ISelfTapeRequestNotificationListPaginated,
  ISelfTapeRequestNotificationStatus,
} from "models/selfTapeRequest";

type SelfTapeRequestNotificationPaginated = {
  pageIndex: number;
  pageSize: number;
  results: ISelfTapeRequestNotification[];
  totalResults: number;
  totalUnreadResults: number;
};

class SelfTapeRequestNotificationService {
  private readonly url: string;

  constructor({ url }: { url: string }) {
    this.url = url;
  }

  public async find(
    params: ISelfTapeRequestNotificationFilterParams,
    abortController?: AbortController
  ): Promise<ISelfTapeRequestNotificationListPaginated> {
    const { data } = await axios.get<SelfTapeRequestNotificationPaginated>(
      `${this.url}/notification`,
      {
        params,
        paramsSerializer(filters: ISelfTapeRequestNotificationFilterParams) {
          return queryString.stringify({ ...filters });
        },
        signal: abortController?.signal,
      }
    );

    return {
      count: data.totalResults,
      items: data.results,
    };
  }

  public async getFilters(
    abortController?: AbortController
  ): Promise<ISelfTapeRequestNotificationFilters> {
    const { data } = await axios(`${this.url}/notification/filters`, {
      method: "get",
      signal: abortController?.signal,
    });

    return data;
  }

  public async updateStatus(
    statuses: ISelfTapeRequestNotificationStatus[],
    abortController?: AbortController
  ) {
    await axios(`${this.url}/notification/status`, {
      method: "post",
      data: statuses,
      signal: abortController?.signal,
    });
  }

  public async getCount(abortController?: AbortController): Promise<number> {
    const response = await axios(`${this.url}/notification/count`, {
      method: "get",
      signal: abortController?.signal,
    });

    return response.data;
  }
}

export default new SelfTapeRequestNotificationService({
  url: config.selfTapesApiUrl,
});
